// src/constants/layout.constants.ts
var DRAWER_WIDTH = {
  /** Default drawer width when expanded */
  OPEN: 280,
  /** Default drawer width when collapsed */
  CLOSE: 70
};

export { DRAWER_WIDTH };
//# sourceMappingURL=chunk-CUKHRH2F.js.map
//# sourceMappingURL=chunk-CUKHRH2F.js.map